module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    green: '#89c429',
                    darkblue: '#0A1C4A',
                    orange: '#EFAC4A',
                    pink: '#dc3f9e',
                    beige: '#fff3dd',
                    gray: '#C1C6D1',
                    lightergray: '#6F707A',
                    lightgray: '#E4E4E4',
                },
            },
        },
        fontFamily: {
            poppins: ['Poppins', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
